import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { FormDirtyService } from '../../features/portfolio-setup/services/form-dirty.service';

export interface CanComponentDeactivate {
  canDeactivate?: () => boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (_component) => {
  const formDirty: FormDirtyService = inject(FormDirtyService);
  if (!formDirty.isDirty()) {
    return true;
  }
  return window.confirm('You have unsaved changes on this page. If you continue, those changes will be discarded. Do you want to continue?');
};
